<script setup lang="ts">
import type { PlanQuery } from "~/types";

const attrs = await usePlanAttr();

interface Props {
  query: PlanQuery;
}

const props = withDefaults(defineProps<Props>(), {
  query: () => ({
    range: {
      name: "",
      value: "",
    },
    tsubo: {
      name: "",
      value: "",
    },
    ktype: {
      name: "",
      value: "",
    },
    kuruma: {
      name: "",
      value: "",
    },
    houi: {
      name: "",
      value: "",
    },
    attr: [],
  }),
});

const label = computed(() => {
  let list = [];
  if (props.query.ktype?.name) {
    list.push(`${props.query.ktype.name}`);
  }

  if (props.query.range?.name) {
    list.push(`${props.query.range.name}`);
  }

  if (props.query.tsubo?.name) {
    list.push(`${props.query.tsubo.name}`);
  }

  if (props.query.kuruma?.name) {
    list.push(`車${props.query.kuruma.name}`);
  }
  if (props.query.houi) {
    list.push(`方位-${props.query.houi}`);
  }

  if (props.query.attr.length) {
    const attr_names = props.query.attr.map((item) => {
      const attr = attrs.value.find((attr) => attr.attr_num === item);
      return attr ? attr.cate_name : "";
    });
    list.push(attr_names.join(","));
  }

  if (list.length) {
    return list;
  }

  return ["すべて"];
});
</script>

<template>
  <p class="w-full overflow-hidden text-ellipsis text-sm">
    <span>条件： </span>
    <span class="mr-2" v-for="item in label">
      {{ item }}
    </span>
  </p>
</template>
